<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Contents</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction: Have a Cookie!</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. The Steel Valley: Western Pennsylvania and Northeast Ohio</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. The Iconic Cookie</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Origins of the Cookie Table</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Baking for the Cookie Table</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Social Media</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Beyond the Wedding Reception</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Beyond the Steel Valley</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. The Celebrity Cookie Table Becomes a Symbol of the Steel Valley</span></p>
<p class="toc1"><span href="#/Afterword" title="Link target outside of Sample">Afterword. Plenty to Think About</span></p>
<p class="toc"><span href="#/AppendixA" title="Link target outside of Sample">Appendix A. The Cookies: Family Favorites and More</span></p>
<p class="toc"><span href="#/AppendixB" title="Link target outside of Sample">Appendix B. Every Day Is Cookie Day!: Cookie Holidays</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?443a1269